var map = {
	"./Braud1.JPG": 4131,
	"./Braud2.JPG": 4660,
	"./Braud3.JPG": 849,
	"./Danskt-rúgbrauð.jpg": 7802,
	"./Fimmkorna-súrdeigsbrauð.png": 1693,
	"./Rúgbrauð.jpg": 5328,
	"./Sumarbrauð.png": 5913,
	"./dodlu_chilli.jpg": 115,
	"./eth_brauð.JPG": 5580,
	"./heilkorna.JPG": 8343,
	"./hvítlauksbrauð.jpeg": 209,
	"./múslíbrauð.JPG": 8765,
	"./olifubraud.JPG": 8929,
	"./picando.JPG": 1840,
	"./snittubraud.JPG": 4687,
	"./sveitabrauð.JPG": 8272,
	"./sólkjarnabraud.JPG": 5955,
	"./súrdeig.JPG": 836,
	"./súrdeig2.JPG": 6820,
	"./Þriggjakorna.JPG": 7987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5275;